<template>
    <div>
        <h1>Usuarios</h1>
        <v-row class="d-flex align-center mb-2">
            <v-spacer></v-spacer>
            <v-col cols="12" md="3">
                <v-btn
                    color="#FFB800"
                    block
                    to="/nuevo-usuario"
                >
                    <v-icon left>mdi-plus</v-icon>
                    Añadir usuario
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col
                v-for="usuario in usuarios"
                :key="usuario.id"
                cols="12"
                sm="6"
                md="4"
                lg="3"
            >
                <v-card class="mx-auto text-center" max-width="240" width="240" height="280">
                    <v-avatar size="70" class="mt-1 mb-0">
                        <v-img
                            :src="obtenerUrlFoto(usuario.foto)"
                            alt="Foto de usuario"
                            width="70"
                            height="70"
                            cover
                        />
                    </v-avatar>

                    <v-card-title class="justify-center">
                        {{ usuario.nombre }}
                    </v-card-title>

                    <v-card-subtitle class="text-caption py-1">
                        Usuario: {{ usuario.usuario }}
                    </v-card-subtitle>

                    <v-card-subtitle class="text-caption py-1">
                        Teléfono: {{ usuario.telefono }}
                    </v-card-subtitle>

                    <v-card-actions class="justify-center py-2 mt-2">
                        <v-tooltip bottom color="blue">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="blue"
                                    small
                                    fab
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="editar(usuario.id)"
                                >
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </template>
                            <span>Editar</span>
                        </v-tooltip>

                        <v-tooltip bottom color="red">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="red"
                                    small
                                    fab
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="eliminar(usuario)"
                                >
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </template>
                            <span>Eliminar</span>
                        </v-tooltip>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="mostrarDialogoEliminar" max-width="500px">
            <dialogo-eliminar :nombre="itemSeleccionado" @cancelar="cerrarDialogoEliminar" @eliminar="confirmarEliminar"/>
        </v-dialog>
        <v-snackbar
        v-model="mostrarMensaje"
        :timeout="3000"
        :color="mensaje.color"
        top
        >
            {{ mensaje.texto }}
        </v-snackbar>
    </div>
</template>
<script>
import DialogoEliminar from '../Dialogos/DialogoEliminar.vue'
import HttpService from '../../Servicios/HttpService' 

export default ({
    name: "Usuarios",
    components: { DialogoEliminar },

    data: () => ({
        cargando: false,
        mostrarDialogoEliminar: false,
        usuario: {},
        usuarios: [],
        itemSeleccionado: "",
        mensaje: {
            texto: "",
            color: ""
        },
        mostrarMensaje: false
    }),

    mounted(){
        this.obtenerUsuarios()
    },

    methods:{
        obtenerUrlFoto(foto) {
            const RUTA_API = "https://masterfitadmin.com/api/";
            if (foto) {
                return `${RUTA_API}imagenes/${foto}`;
            } else {
                return `${RUTA_API}imagenes/usuario.png`;
            }
        },

        editar(idUsuario){
            this.$router.push({
                name: "EditarUsuario",
                params: { id: idUsuario },
            })
        },

        eliminar(usuario){
            this.itemSeleccionado = usuario.nombre
            this.usuario = usuario
            this.mostrarDialogoEliminar = true
        },

        cerrarDialogoEliminar(){
            this.mostrarDialogoEliminar = false
            this.usuario = {}
        },

        confirmarEliminar(){
            this.cargando = true
            let payload = {
                metodo: "delete",
                id: this.usuario.id,
                rolUsuario: localStorage.getItem('rolUsuario')
            }
            HttpService.eliminar("usuarios.php", payload)
            .then(eliminado => {
                // dependiendo de la forma de la respuesta puede ser boolean o un objeto
                if(eliminado && (eliminado === true || eliminado.resultado === true)){
                    this.mostrarDialogoEliminar = false
                    this.mostrarMensaje = true
                    this.mensaje.texto = "Usuario eliminado"
                    this.mensaje.color = "success"
                    this.cargando = false
                    this.obtenerUsuarios()
                } else {
                    // mostrar un error genérico
                    this.mostrarMensaje = true
                    this.mensaje.texto = "Error al eliminar usuario" + (eliminado && eliminado.mensaje ? (": " + eliminado.mensaje) : "")
                    this.mensaje.color = "error"
                    this.cargando = false
                }
            })
            .catch(err => {
                console.error('Fallo petición eliminar:', err);
                this.mostrarMensaje = true
                this.mensaje.texto = "Error de conexión al eliminar"
                this.mensaje.color = "error"
                this.cargando = false
            })
        },

        obtenerUsuarios(){
            this.cargando = true
            let payload = {metodo: "get"}
            HttpService.obtenerConDatos(payload, "usuarios.php")
            .then(respuesta => {
                this.usuarios = respuesta
                this.cargando = false
            })
        }
    }
})
</script>



// WEBPACK FOOTER //
// src/components/Usuarios/Usuarios.vue